var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component } from "react";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Icon, Icons } from "../../../atoms/icon";
import { Modal } from "../../../atoms/parental-control/components/modal";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import { CustomPin } from "../components/customPin";
import * as styles from "../firstFlowModals/styles.css";
import { encryptMessage } from "../../../../utils/encrption";
import { ErrorMessage } from "../components/errorMessage";
import { isHTMLInputElement } from "../../../../utils/common";
import { Button, ButtonVariant } from "../../../../components/atoms/button";
export class CreatePin extends Component {
    constructor(props) {
        super(props);
        this.handleInput = (e) => {
            const target = e.target;
            if (isHTMLInputElement(target)) {
                const isnumber = /^-?\d*$/.test(target.value);
                if (isnumber) {
                    const inputvalue = target.value;
                    const name = target.name;
                    const partialState = {};
                    partialState[name] = inputvalue;
                    this.setState(partialState, () => {
                        this.checkPinValidation();
                    });
                }
            }
        };
        this.checkPinValidation = () => {
            const { pin1, pin2, pin3, pin4, cpin1, cpin2, cpin3, cpin4 } = this.state;
            const pin = pin1.concat(pin2, pin3, pin4);
            const confirmPin = cpin1.concat(cpin2, cpin3, cpin4);
            this.props.flow === "forgotPin" && this.encryptForgotPin(pin);
            if (pin.length === 4 && confirmPin.length === 4) {
                if (pin !== confirmPin) {
                    this.setState({
                        isPinMatched: true,
                        isButtonDisabledConfirmPin: false,
                    });
                }
                else {
                    this.encrypt(confirmPin);
                    this.setState({
                        isPinMatched: false,
                        isButtonDisabledConfirmPin: true,
                    });
                }
            }
        };
        this.onContinuePin = () => {
            const { isButtonDisabled, encryptedValue, isButtonDisabledConfirmPin } = this.state;
            const { flow } = this.props;
            if (flow === "forgotPin") {
                isButtonDisabled &&
                    isButtonDisabledConfirmPin &&
                    this.props.onContinue(encryptedValue);
            }
            else {
                isButtonDisabled && this.props.onContinue(encryptedValue);
            }
        };
        this.canSubmit = () => {
            const { pin1, pin2, pin3, pin4, cpin1, cpin2, cpin3, cpin4 } = this.state;
            const pin = pin1.concat(pin2, pin3, pin4);
            const confirmPin = cpin1.concat(cpin2, cpin3, cpin4);
            if (pin.length === 4 && confirmPin.length === 4) {
                return true;
            }
            else
                return false;
        };
        this.state = {
            pin1: "",
            pin2: "",
            pin3: "",
            pin4: "",
            cpin1: "",
            cpin2: "",
            cpin3: "",
            cpin4: "",
            isPinMatched: false,
            encryptedValue: "",
            pin: "",
            confirmPin: "",
            isNewPinMatchCurrentPin: false,
            isButtonDisabled: false,
            isButtonDisabledConfirmPin: false,
        };
    }
    encryptForgotPin(text) {
        return __awaiter(this, void 0, void 0, function* () {
            const encryptedValue = yield encryptMessage(text);
            if (this.props.pinValidation &&
                this.props.pinValidation === encryptedValue) {
                this.setState({ isNewPinMatchCurrentPin: true, isButtonDisabled: false });
            }
            else {
                this.setState({
                    encryptedValue,
                    isNewPinMatchCurrentPin: false,
                    isButtonDisabled: true,
                });
            }
        });
    }
    encrypt(text) {
        return __awaiter(this, void 0, void 0, function* () {
            const encryptedValue = yield encryptMessage(text);
            if (this.props.pinValidation &&
                this.props.pinValidation === encryptedValue) {
                this.setState({ isNewPinMatchCurrentPin: true, isButtonDisabled: false });
            }
            else {
                this.setState({
                    encryptedValue,
                    isNewPinMatchCurrentPin: false,
                    isButtonDisabled: true,
                });
            }
        });
    }
    render() {
        const value = this.canSubmit();
        const { pin1, pin2, pin3, pin4, cpin1, cpin2, cpin3, cpin4, isPinMatched, isNewPinMatchCurrentPin, isButtonDisabled, isButtonDisabledConfirmPin, } = this.state;
        const { header, pinlabel, confirmPinLabel, label, flow } = this.props;
        return (React.createElement(Modal, { label: label, currentPinMatchesNewPin: isNewPinMatchCurrentPin, errorMsg: "PIN does not match", showErrorMsg: isPinMatched },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.createPinCardContainer, id: "pinCreationWrapper" },
                    React.createElement("div", { className: styles.createPinWrapper, id: "pinCreationHeader" },
                        React.createElement("div", { className: styles.goBack, onClick: () => window.history.back(), id: "backArrow" },
                            React.createElement(Icon, { type: Icons.LeftArrow, className: styles.backArrow, color: "white" })),
                        React.createElement(Typography, { classNameM: M.of(styles.header), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                            React.createElement(React.Fragment, null, header))),
                    React.createElement("div", { className: styles.customPinWrapper, id: "newPin" },
                        React.createElement(CustomPin, { label: pinlabel, handleInput: this.handleInput, pin1: pin1, pin2: pin2, pin3: pin3, pin4: pin4, name: "pin", nextFocusID: "cpin1", autoFocus: pin1.length >= 1 ? false : true })),
                    isNewPinMatchCurrentPin && (React.createElement(ErrorMessage, { children: "You used this PIN recently. Please use a new Pin" })),
                    React.createElement("div", { className: styles.customPinWrapper, id: "confirmPin" },
                        React.createElement(CustomPin, { label: confirmPinLabel, handleInput: this.handleInput, pin1: cpin1, pin2: cpin2, pin3: cpin3, pin4: cpin4, name: "cpin", nextFocusID: "cpin4" })),
                    isPinMatched && React.createElement(ErrorMessage, { children: "PIN does not match" })),
                React.createElement("div", { className: styles.buttonContiner }, flow === "forgotPin" ? (React.createElement("div", { id: "continueButton", onClick: () => this.onContinuePin() },
                    React.createElement(Button, { children: "CONTINUE", variant: value && isButtonDisabled && isButtonDisabledConfirmPin
                            ? ButtonVariant.Primary
                            : ButtonVariant.Disabled, onClickM: M.of(() => this.onContinuePin()) }))) : (React.createElement("div", { id: "continueButton" },
                    React.createElement(Button, { children: "CONTINUE", variant: value && isButtonDisabled
                            ? ButtonVariant.Primary
                            : ButtonVariant.Disabled, onClickM: M.of(() => this.onContinuePin()) })))))));
    }
}

